import React from 'react'
import styled, { css } from 'styled-components'
import RoundedButton from '../MasterComponents/Buttons/RoundedButton'
import { useImageTransform } from '../ImagesCarousel/ImageTransformProvider'

interface ImageRotateButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  cssProp?: ReturnType<typeof css>
  'data-testid'?: string
}

const StyledButton = styled.div<{ $css?: ReturnType<typeof css> }>`
  z-index: 10;
  user-select: none;
  ${props => props.$css}
`

const ImageRotateButtonBase: React.FC<ImageRotateButtonProps> = ({
  onClick,
  cssProp,
  'data-testid': testId,
}) => {
  return (
    <StyledButton $css={cssProp}>
      <RoundedButton
        onClick={onClick}
        type='secondary'
        size='M'
        data-testid={testId}
      >
        <Icon />
      </RoundedButton>
    </StyledButton>
  )
}

export const ImageRotateButton: React.FC<
  Omit<ImageRotateButtonProps, 'onClick'>
> = ({ cssProp, 'data-testid': testId }) => {
  const { rotate90 } = useImageTransform()
  return (
    <ImageRotateButtonBase
      onClick={rotate90}
      cssProp={cssProp}
      data-testid={testId}
    />
  )
}

export default ImageRotateButton

const Icon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.1612 0.043015C9.70371 -0.216862 12.0159 0.722929 13.6475 2.35259L14.2881 1.70219C14.9187 1.0726 15.9998 1.52258 16.0001 2.41216V6.002C16 6.55177 15.5495 7.00193 14.9991 7.002H11.4053C10.5146 7.002 10.0739 5.92196 10.7042 5.29204L12.2159 3.78227C11.1349 2.69262 9.65373 2.0031 7.99225 2.00298C4.24843 2.00298 1.29495 5.44204 2.13581 9.32133C2.60631 11.5408 4.39811 13.3499 6.62018 13.8399C9.58317 14.4998 12.2966 12.9608 13.4278 10.5313C13.588 10.2014 13.9383 10.001 14.3087 10.001C15.0491 10.0013 15.5291 10.7708 15.209 11.4405C13.9278 14.1299 11.1853 15.9999 7.99225 16C3.25742 16 -0.496787 11.9107 0.0537752 7.06157C0.464212 3.39226 3.48746 0.412946 7.1612 0.043015Z'
      fill='#717284'
    />
  </svg>
)
